import { Input as InputAntd, InputProps, Select, SelectProps } from 'antd';
import { SearchProps } from 'antd/lib/input';
import ReactInputMask from 'react-input-mask';

const Input = (props: InputProps) => {
  return (
    <InputAntd
      {...props}
    />
  );
};

export interface MaskedProps {
  mask: string;
  maskChar?: string;
  formatChars?: object;
  alwaysShowMask?: boolean;
  inputRef?: React.RefObject<HTMLInputElement>;
}

export interface MaskedInputProps extends InputProps, MaskedProps {}

Input.Masked = (props: MaskedInputProps) => {
  return (
    <ReactInputMask {...props}>
      {(inputProps: any) => <Input {...inputProps} disabled={props.disabled ? props.disabled : null} />}
    </ReactInputMask>
  );
};

export interface MaskedSearchProps extends SearchProps, MaskedProps {}

Input.MaskedSearch = (props: MaskedSearchProps) => {
  return (
    <ReactInputMask {...props}>
      {(inputProps: any) => <InputAntd.Search {...inputProps} />}
    </ReactInputMask>
  );
};

Input.Search = (props: SearchProps) => {
  return (
    <InputAntd.Search {...props} />
  );
};

Input.Select = (props: SelectProps) => {
  return (
    <Select {...props} />
  );
};

export { Input };
export default Input;
